import { createAsyncThunk } from '@reduxjs/toolkit'
import * as API_DIALOGS from '../../shared/http/message'

export const fetchDialogs = createAsyncThunk('dialogs/fetchAll', () => API_DIALOGS.getDialogs())

export const fetchMessagesByDialogId = createAsyncThunk('dialogs/fetchMessagesById', (id: number) =>
    API_DIALOGS.getMessages(id)
)
